import { Pipe, PipeTransform } from '@angular/core';
import { ActivityCategory, categoryLabel } from './activity.model';

// Pure pipe wrapping the model helper, so templates memoise the label instead of
// recomputing it each change-detection cycle. The logic lives in one place —
// activity.model.ts. (Relative timestamps reuse the shared `timeago` pipe.)

@Pipe({ name: 'activityCategoryLabel' })
export class ActivityCategoryLabelPipe implements PipeTransform {
  transform(category: ActivityCategory | null | undefined): string {
    return category ? categoryLabel(category) : '';
  }
}
